var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.70926H16M6 7.70926H18M10.5 14.7093V18.7093L14.5 16.7093L10.5 14.7093ZM6 21.7093H18C19.1046 21.7093 20 20.8138 20 19.7093V13.7093C20 12.6047 19.1046 11.7093 18 11.7093H6C4.89543 11.7093 4 12.6047 4 13.7093V19.7093C4 20.8138 4.89543 21.7093 6 21.7093Z",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.ad9eedf24190a1bd7f26b2c98a13b71f.svg";
export { ForwardRef as ReactComponent };